import React from 'react';
import Video from './Video';
import Text from './Text';
import FIBText from './FIBText';
import DisplayTemplate from '../displayTemplate';

export default function TextAndVideo({ contentType, content, disabled, selected, enableTextToAudio, handleAnswerSelection, contentDisplayType, contentUrl, mediaStyle, overrideHTML, renderDefault = false, helpText, templateType, ...props }) {

    const VideoComponent = () => <Video renderDefault={true} contentUrl={contentUrl} />;
    const TextComponent = () => contentDisplayType == 'FIB' ? <FIBText disabled={disabled} value={selected} renderDefault={true} handleAnswerSelection={handleAnswerSelection} length={props.length} content={content} /> : <Text renderDefault={true} enableTextToAudio={enableTextToAudio} content={content} helpText={helpText} />;

    return (<DisplayTemplate templateType={templateType} components={[TextComponent, VideoComponent]} {...props} />)

}